module.exports = {
  languages: ['ja', 'en'],
  emailAddress: 'www-admins@ertl.jp',
};
